import { render } from "./VectorCoastersItem.vue?vue&type=template&id=2c33c788&scoped=true"
import script from "./VectorCoastersItem.vue?vue&type=script&lang=js"
export * from "./VectorCoastersItem.vue?vue&type=script&lang=js"

import "./VectorCoastersItem.vue?vue&type=style&index=0&id=2c33c788&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c33c788"]])

export default __exports__